// src/services/CartService.js

// ✅ Referencia a la API (Asegúrate de que el archivo sea pedidos.js en minúsculas)
const API = '/api/pedidos'; 
const CART_STORAGE_KEY = 'mediexpress_cart';

export const getCart = () => {
    const cart = localStorage.getItem(CART_STORAGE_KEY);
    return cart ? JSON.parse(cart) : [];
};

// Busca esta función en CartService.js
export const addToCart = (product) => {
    let cart = getCart();
    // CAMBIO: Usar productos_id para comparar
    const existing = cart.find(item => item.productos_id === product.productos_id);

    if (existing) {
        existing.cantidad += 1;
    } else {
        // Guardamos el producto asegurando que tenga la propiedad 'precio' 
        // para que toFixed() no falle luego
        cart.push({ 
            ...product, 
            id: product.productos_id, // Mantenemos un alias 'id' para compatibilidad
            precio: product.precio_venta, 
            cantidad: 1 
        });
    }
    localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));
    window.dispatchEvent(new Event('cartUpdated'));
    return cart;
};

export const removeFromCart = (productId) => {
    let cart = getCart().filter(item => item.productos_id !== productId);
    localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(cart));

    window.dispatchEvent(new Event('cartUpdated'));
    
    return cart;
};

export const sendToWhatsApp = async (cart) => {
    // Calculamos el total de nuevo por seguridad
    const total = cart.reduce(
        (acc, item) => acc + ((item.precio || item.precio_unitario || 0) * item.cantidad), 
        0
    );
    
    try {
        // ✅ Usamos la constante API definida arriba
        const response = await fetch(API, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: cart, total: total })
        });

        if (!response.ok) {
            const errorMsg = await response.text();
            throw new Error("Fallo al guardar en BD: " + errorMsg);
        }

        const data = await response.json();

        // Si la base de datos nos devuelve el UUID
        if (data.uuid) {
            // 1. Limpiamos el carrito local
            localStorage.removeItem(CART_STORAGE_KEY);
            
            // 2. Generamos el link de visualización (Novatech)
            const urlPedido = `https://novatechz.netlify.app/carrito/ver/${data.uuid}`;
            const mensaje = `¡Hola!\nQuiero concretar este pedido:\n${urlPedido}`;
            
            // 3. Redirección a WhatsApp
            window.location.href = `https://wa.me/51906145083?text=${encodeURIComponent(mensaje)}`;
        }
    } catch (e) {
        console.error("Error en sendToWhatsApp:", e);
        alert("No se pudo procesar el pedido. Verifica tu conexión.");
    }
};